var HomePageOfferingDTO = /** @class */ (function () {
    function HomePageOfferingDTO(primary, seco, ter) {
        this.primary = primary;
        this.secondary = seco;
        this.tertiary = ter;
    }
    return HomePageOfferingDTO;
}());
export default HomePageOfferingDTO;
